import { memo, useState } from 'react'
import { SpinningLoader } from 'common-components'
import { COLORS } from 'consts/colors'
import CloseIcon from 'assets/svgr-icons/Close.svg'

import Icon from 'common-components/Icon'

import { IReferenceMediaItem } from 'types/aiVideo'
import * as Styled from './styled'

const MultiRefImageItem: React.FC<{
  item: IReferenceMediaItem
  onRemove: (id: string) => void
}> = memo(({ item, onRemove }) => {
  const [isImgLoading, setIsImgLoading] = useState(true)
  const showSpinner = item.isLoading || isImgLoading

  return (
    <Styled.ImageOuterContainer>
      <Styled.ImageWrapper>
        {showSpinner && (
          <SpinningLoader
            className="loading-spinner"
            size={32}
            loaderColor={COLORS.primaryDark}
          />
        )}
        {item.url && (
          <Styled.Image
            src={item.url}
            alt={`ref-${item.id}`}
            onLoad={() => setIsImgLoading(false)}
            $isLoading={showSpinner}
          />
        )}
      </Styled.ImageWrapper>
      {!item.isLoading && (
        <Styled.RemoveButton onClick={() => onRemove(item.id)}>
          <Icon icon={<CloseIcon />} size="small" color="secondarySemiLight" />
        </Styled.RemoveButton>
      )}
    </Styled.ImageOuterContainer>
  )
})

MultiRefImageItem.displayName = 'MultiRefImageItem'

export default MultiRefImageItem
